import EmailDisplayMode from "@/domain/enums/EmailDisplayMode";
import DashboardWidgetSettings from "./DashboardWidgetSettings";

type DisplayPreferencesProps = {
    emailDisplayMode: EmailDisplayMode;
    dashboardWidgets: DashboardWidgetSettings;
};

export default class DisplayPreferences {
    emailDisplayMode: EmailDisplayMode;

    dashboardWidgets: DashboardWidgetSettings;

    constructor({
        emailDisplayMode,
        dashboardWidgets,
    }: DisplayPreferencesProps) {
        this.emailDisplayMode = emailDisplayMode;
        this.dashboardWidgets = dashboardWidgets;
    }
}
